export class Filter {
    constructor(field, operator, value, type) {
        this.field = field;
        this.operator = operator;
        this.value = value;
        this.type = type;
    }
    getField() {
        return this.field;
    }
    getOperator() {
        return this.operator;
    }
    getValue() {
        return this.value;
    }
    getType() {
        return this.type;
    }
}
//# sourceMappingURL=filter.js.map